/* global __WEB_URL__, siteTittle */
import 'highlight.js/styles/github.css';
import '@trisotech/ribbon-bar/dist/css/ribbon-bar-trisoblue.css';
import 'font-awesome/css/font-awesome.min.css';
import '../css/site.css';

import 'highlight.js';
import '@trisotech/ribbon-bar/dist/js/ribbon-bar.js';

import './01-nav.js';
import './02-on-this-page.js';
import './03-fragment-jumper.js';
import './04-page-versions.js';
import './05-mobile-navbar.js';
import './06-copy-to-clipboard.js';


let getUserLogin = async () => {
    var params = new URLSearchParams({
        'mode': 'json'
    });

    let response = await fetch(__WEB_URL__ + "/publicapi/login?"+ params.toString(), {
        mode: 'cors',
        credentials: 'include'
    });
    if (!response.ok) {
        throw new Error();
    }

    let data = await response.json();

    if (data.data && data.data.email) {
        return {
            name: data.data.name,
            image:data.data.photoThumbnail
        };
    } else {
        throw new Error();
    }
};

let getNavigation = async () => {
    var params = new URLSearchParams({
        'mode': 'json'
    });

    let response = await fetch(__WEB_URL__ + "/publicapi/navigation?" + params.toString(), {
        mode: 'cors',
        credentials: 'include'
    });
    if (!response.ok) {
        throw new Error();
    }

    let data = await response.json();

    if (data.data) {

        return data.data.childs.map(n => n.linkElement)
            .filter(n => n.id.includes("solution-"))
            .map(n => {
                return {
                    id: n.id,
                    description: n.name,
                    callback: n.url,
                    imageURL: n.iconURL,
                    rank: Number(n.id.substring(9))
                };
            });

    } else {
        throw new Error();
    }
};

(async () => {
    let userInfo = {
        name:'',
        image:''
    };

    //container of products
    let nav = null;

    try {
        userInfo = await getUserLogin();
        nav = await getNavigation();
    } finally {
        $("#ribbon-bar").ribbonBar({
            brand: siteTittle,
            tabs:[],
            commands:"",
            solutionDropdown: nav,
            saveCommand: '',
            tabCommands:[],
            identity:{
                name:userInfo.name,
                image:userInfo.photoThumbnail
            }
        });
    }
})();
